/**
 * MIRA Input Component
 * Wraps Shadcn Input with MIRA design system styles
 */

import React from 'react';
import { Input as ShadcnInput } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/input.module.css';

export const Input = React.forwardRef(
  ({
    className,
    label,
    error,
    helperText,
    required,
    id,
    // Filter out custom props that shouldn't reach the DOM
    isError,
    setIsValueVisible,
    propertyId,
    propertyName,
    isCurrency,
    isSubmitted,
    // Capture remaining props
    ...props
  }, ref) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <div className={styles.inputWrapper}>
        {label && (
          <Label htmlFor={inputId} className={cn(styles.label, required && styles.required)}>
            {label}
          </Label>
        )}
        <ShadcnInput
          ref={ref}
          id={inputId}
          className={cn(
            styles.miraInput,
            (error || isError) && styles.error,
            className
          )}
          {...props}
        />
        {error && (
          <span className={styles.errorText}>{error}</span>
        )}
        {helperText && !error && (
          <span className={styles.helperText}>{helperText}</span>
        )}
      </div>
    );
  }
);

Input.displayName = 'MiraInput';
